/* eslint @typescript-eslint/no-explicit-any: 0 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, retry, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvService } from '../configuration/env.service';
import { IFopConfig, IFopTokens } from './fop-mode.model';

@Injectable({
    providedIn: 'root'
})
export class FopModeService {
    private readonly FOP_CONFIG_SESSION_KEY = 'FopConfig';
    private readonly FOP_CONFIG_URL = '/mop/assets/fop-config.json';

    constructor(private readonly http: HttpClient, private readonly envService: EnvService) {}

    getFopConfig(): Observable<IFopConfig> {
        const fopConfig = sessionStorage.getItem(this.FOP_CONFIG_SESSION_KEY);
        if (fopConfig !== null) {
            return of(JSON.parse(fopConfig));
        }

        return this.http.get<IFopConfig>(this.FOP_CONFIG_URL).pipe(
            switchMap(result => {
                sessionStorage.setItem(this.FOP_CONFIG_SESSION_KEY, JSON.stringify(result));
                return of(result);
            }),
            retry({ delay: 1000, count: 3 })
        );
    }

    getFopTokens(fopConfig: IFopConfig): Observable<IFopTokens> {
        if (!fopConfig) {
            throw new Error('Fop config is undefined');
        }
        if (!fopConfig.username) {
            throw new Error('Fop config username is undefined');
        }
        if (!fopConfig.password) {
            throw new Error('Fop config password is undefined');
        }
        return this.http
            .post(
                `${this.envService.config.keycloak.url}/realms/${this.envService.config.keycloak.realm}/protocol/openid-connect/token`,
                `grant_type=password&scope=openid&client_id=${this.envService.config.keycloak.clientId}&username=${fopConfig.username}&password=${fopConfig.password}`,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            )
            .pipe(
                map((response: any) => {
                    return {
                        accessToken: response.access_token,
                        refreshToken: response.refresh_token,
                        idToken: response.id_token
                    };
                })
            );
    }
}
